import { useEffect, useState } from "react";
import useMain from "../../common/MainContext";
import LoginData from "../../repository/LoginData";
import FormBorder from "../../components/formBorder/FormBorder";
import FormUnsubscribe from "../../components/forms/unsubscribe/FormUnsubscribe";

export default function PageUnsubscribe(props) {
    const { setLanguage } = useMain();
    const [regLoginData, setRegLoginData] = useState();

    useEffect(() => {
        debugger
        const urlLoginData = new LoginData(props.currentSearchParams.token);

        if (!(urlLoginData.tokenData.token.type === 'REGISTRATION' && urlLoginData.tokenData.user.id)) {
            setRegLoginData({});
            return;
        }

        setLanguage(() => (props.currentSearchParams.language || 'en'));
        setRegLoginData(urlLoginData);
    }, [])

    return (
        <div className="page-unsubscribe">
            <FormBorder
                form={
                    <FormUnsubscribe
                        regLoginData={regLoginData}
                    //callback={() => setSearchParams({})}
                    />
                }

            />
        </div>
    )
}
